/* eslint-disable class-methods-use-this */

export default class BaseImageImporter {
  constructor(id) {
    this.id = id
  }

  import() {
    throw new Error('import() not implemented')
  }
}
